import React, { useRef, useState } from "react";
import "./Contact.css";

function Contact() {
  const form = useRef();
  const [done, setDone] = useState(false);
  const [sending, setSending] = useState(false);
  const [failed, setFailed] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    setDone(false);
    setFailed(false);

    const data = new FormData(form.current);
    const payload = {
      name: String(data.get("user_name") || "").trim(),
      email: String(data.get("user_email") || "").trim(),
      message: String(data.get("message") || "").trim(),
    };

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));

      if (!response.ok || !result.ok) {
        throw new Error(result.error || "send_failed");
      }

      setDone(true);
      form.current.reset();
    } catch (error) {
      console.error("Contact error:", error);
      setFailed(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="contact-form section" id="Contact">
      <div className="contact-inner container">
        <div className="w-left">
          <div className="awesome">
            <div className="section-heading">
              <span>Prendre contact</span>
              <span className="accent">Contactez-moi</span>
            </div>
            <p className="section-copy">
              Une idée de projet, une opportunité en alternance ou une
              collaboration ? Écrivez-moi, je vous réponds rapidement.
            </p>
            <div className="blur blur1" style={{ background: "#ABF1FF94" }} />
          </div>
        </div>

        <div className="c-right">
          <form ref={form} onSubmit={sendEmail}>
            <label className="field">
              <span>Nom</span>
              <input
                type="text"
                name="user_name"
                className="user"
                placeholder="Votre nom"
                required
              />
            </label>
            <label className="field">
              <span>E-mail</span>
              <input
                type="email"
                name="user_email"
                className="user"
                placeholder="vous@email.com"
                required
              />
            </label>
            <label className="field">
              <span>Message</span>
              <textarea
                name="message"
                className="user"
                placeholder="Parlez-moi de votre projet"
                rows={5}
                required
              />
            </label>
            <button type="submit" className="button c-button" disabled={sending}>
              {sending ? "Envoi..." : "Envoyer"}
            </button>
            {done ? (
              <p className="form-success" role="status">
                Merci pour votre message, je vous répondrai rapidement.
              </p>
            ) : null}
            {failed ? (
              <p className="form-error" role="alert">
                Envoi impossible. Réessaie dans un instant.
              </p>
            ) : null}
            <div
              className="blur c-blur1"
              style={{ background: "var(--purple)" }}
            />
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
